<template>
  <div class="about-us-page">
    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <h4 class="card-title mb-0">
          <i class="bi bi-info-circle me-2"></i>About Us Content
        </h4>
        <button class="btn btn-primary" @click="saveContent">
          <i class="bi bi-save me-2"></i>Save
        </button>
      </div>
      <div class="card-body">
        <div class="mb-3">
          <label class="form-label">Page Title</label>
          <input type="text" class="form-control" v-model="content.title">
        </div>
        <div class="mb-3">
          <label class="form-label">Main Content</label>
          <textarea class="form-control" rows="10" v-model="content.body"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      content: {
        title: 'About EDCTP',
        body: 'Content for About Us page...'
      }
    }
  },
  methods: {
    saveContent() {
      this.$toast?.success('Content saved successfully!')
    }
  }
}
</script>

<style scoped>
.about-us-page {
  padding: 1rem 0;
}
</style>
